export default "__VITE_ASSET__C8$omHxA__"